import languages from '@/languages'

export default {
  state: {
    currentLanguage: 'english',
    language () {
      return languages[this.currentLanguage]
    }
  },

  mutations: {
    changeLanguage (state, language) {
      state.currentLanguage = language
      localStorage.setItem('language', language)
    },
    initLanguage (state) {
      const language = localStorage.getItem('language')
      if (language) state.currentLanguage = localStorage.getItem('language')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/languages.js